var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7509 10.1941C18.7509 9.47471 18.6913 8.94971 18.5624 8.40527H10.1795V11.6525H15.1001C15.0009 12.4594 14.4652 13.6747 13.2747 14.4913L13.258 14.6L15.9085 16.6123L16.0922 16.6303C17.7786 15.1039 18.7509 12.858 18.7509 10.1941Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1789 18.75C12.5896 18.75 14.6133 17.9722 16.0915 16.6305L13.2741 14.4916C12.5201 15.0068 11.5082 15.3666 10.1789 15.3666C7.81779 15.3666 5.81385 13.8402 5.0995 11.7305L4.99479 11.7392L2.23874 13.8295L2.2027 13.9277C3.67093 16.786 6.6868 18.75 10.1789 18.75Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.1002 11.7307C4.91171 11.1863 4.80263 10.6029 4.80263 10.0002C4.80263 9.39734 4.91171 8.81403 5.09028 8.2696L5.08529 8.15365L2.2947 6.02979L2.20339 6.07235C1.59826 7.25847 1.25104 8.59044 1.25104 10.0002C1.25104 11.4099 1.59826 12.7418 2.20339 13.9279L5.1002 11.7307Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1789 4.63331C11.8555 4.63331 12.9864 5.34303 13.6313 5.93612L16.1511 3.525C14.6035 2.11528 12.5896 1.25 10.1789 1.25C6.68682 1.25 3.67094 3.21387 2.2027 6.07218L5.0896 8.26943C5.81387 6.15972 7.81782 4.63331 10.1789 4.63331Z",
    fill: "#EB4335"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.3ed082782934523c0daeecf92ebc29b7.svg";
export { ForwardRef as ReactComponent };